import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralButtonsButtonSortSignature {
  Args: {
    isAscending: boolean;
    isSorted: boolean;
  };
}

const GeneralButtonsButtonSort = <template>
  <div class="button-sort flex items-center justify-center">
    {{#if @isSorted}}
      {{#if @isAscending}}
        <PrismIcon @name="sort-asc" />
      {{else}}
        <PrismIcon @name="sort-desc" />
      {{/if}}
    {{else}}
      <PrismIcon @name="sort" />
    {{/if}}
  </div>
</template> satisfies TOC<GeneralButtonsButtonSortSignature>;

export default GeneralButtonsButtonSort;
